import { gql } from '@apollo/client'

export const SIGNUP_WITH_COMPANY = gql`
  mutation RegisterWithCompany($input: RegisterWithCompanyInput) {
    registerWithCompany(input: $input) {
      token
    }
  }
`

export const SIGNUP_WITHOUT_COMPANY = gql`
  mutation RegisterWithoutCompany($input: RegisterWithoutCompanyInput) {
    registerWithoutCompany(input: $input) {
      token
    }
  }
`
